import * as angular from "angular";

export class CampaignService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/campaign";
    }

    info(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/info/" + data.id, data);
    }

    ipInfo(): Promise<object> {
        return this.$http.get(this.apiRoot + "/ip_info");
    }

    charges(data: any): Promise<object> {
        return this.$http.get("/v2/campaign/charges/" + data.id, data);
    }

    warnings(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/warnings", data);
    }

    userCreated(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/my", data);
    }

    cancelCampaigns(data: any): Promise<object> {
        return this.$http.post("/v2/campaign/cancel", data);
    }

    hasSampleData(): Promise<object> {
        return this.$http.get("/v2/campaign/has_sample_data");
    }

    canEnableSampleData(): Promise<object> {
        return this.$http.get("/v2/campaign/can_enable_sample_data");
    }

    deleteSampleData(): Promise<object> {
        return this.$http.post("/v2/campaign/delete_sample_data");
    }

    restoreSampleData(): Promise<object> {
        return this.$http.post("/v2/campaign/restore_sample_data");
    }

    limits(data: any): Promise<object> {
        return this.$http.get("/v2/campaignlimit/" + data.id, data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(
            this.apiRoot + "/update/" + data.campaignid,
            data
        );
    }

    live(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/live", data);
    }

    checkCampaignUpgradePending(data: any): Promise<object> {
        return this.$http.get("/v2/campaignupgrade", data);
    }

    acknowledgeUpgrade(data: any): Promise<object> {
        return this.$http.post("/v2/campaignupgrade", data);
    }

    createTailoredData(data: any): Promise<object> {
        return this.$http.post("/v2/campaign/createTailoredData", data);
    }

    setupSteps(): Promise<object> {
        return this.$http.get(this.apiRoot + "/setupsteps");
    }

    markSetupStepCompleted(id: number): Promise<object> {
        return this.$http.post(this.apiRoot + "/setupstep/completed/" + id);
    }

    userCustomFields(data?: any): Promise<object> {
        return this.$http.get("/v2/campaign/userCustomFields", data);
    }

    getKinds(): Promise<object> {
        return this.$http.get("/v2/campaign/kind");
    }
}

angular.module("vcServices").service("CampaignService", CampaignService);
